export const SPECIAL_BOARD_ALIAS = [
  'SUSPENDED',
  'UNSUSPENDED',
  'FCA',
  'FCA-OUT',
  'UMA',
];

export const COLUMN_KEY = {
  SYMBOL: 'symbol',
  SYMBOL_FCA: 'symbol_fca',
  COMPANY: 'company',
  MULTIPLIER: 'multiplier',
  PRICE: 'price',
  CHANGE: 'change',
  MARKET_CAP: 'marketcap',
  LIQUIDITY: 'liquidity',
  YIELD: 'yield',
  BID_PRICE: 'bid_price',
  OFFER_PRICE: 'offer_price',
  PERFORMANCE: 'performance',
  COUPON: 'coupon',
  NEXT_COUPON_DATE: 'next_coupon_date',
  DUE_DATE: 'due_Date',
  HAIRCUT: 'haircut',
};

export const SPECIAL_SUBSECTOR_ALIAS = {
  TRADING_LIMIT: 'TRADINGLIMIT',
  FCA: 'FCA',
  SUSPENDED: 'SUSPENDED',
  UNSUSPENDED: 'UNSUSPENDED',
  FCA_OUT: 'FCA-OUT',
  UMA: 'UMA',
};
